const STOCK_URL = "https://preview.insightwin.com/backend/stock";
// const STOCK_URL = "http://localhost:7100/backend/stock";

export default STOCK_URL;
